import { createSocketSingleton } from '@shootout-comps/core';

// In production, connect to the same origin so nginx can proxy /socket.io/.
// In development, connect directly to the API dev server on :3001.
const {
  getSocket, useSocket, useMatchSocket, useWatchMatchSocket, useTournamentSocket,
  useSocketEvents, useConnectionStatus, setAccessTokenGetter,
} = createSocketSingleton(() =>
  process.env.NODE_ENV === 'production' ? window.location.origin : 'http://localhost:3001',
);

export {
  getSocket, useSocket, useMatchSocket, useWatchMatchSocket, useTournamentSocket,
  useSocketEvents, useConnectionStatus, setAccessTokenGetter,
};
